module.exports = __webpack_public_path__ + "static/media/tab_cup_select.e5b2baea.svg";